import { z } from 'zod';

/**
 * Generate-dialog form. Guards the period client-side so we never hit the
 * endpoint's 400 (missing/invalid year, month outside 1–12). `month` is kept as
 * a string (the select value) and converted to a number when fetching.
 */
export const deklaracjaPreviewSchema = z.object({
  year: z.coerce
    .number()
    .int('Rok musi być liczbą całkowitą')
    .min(2020, 'Rok nie może być wcześniejszy niż 2020')
    .max(2100, 'Nieprawidłowy rok'),
  month: z.string().min(1, 'Wybierz miesiąc'),
});

/** Form values while editing (year may still be a raw input value). */
export type DeklaracjaPreviewFormInput = z.input<typeof deklaracjaPreviewSchema>;
/** Parsed values handed to the submit handler (year coerced to a number). */
export type DeklaracjaPreviewFormData = z.output<typeof deklaracjaPreviewSchema>;
